import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box } from '@mui/material';

import PageWrapper from '../../common/PageWrapper';
import { useMerchant } from '../../contexts/MerchantContext';
import { useCanManagePortalUsers } from '../../hooks';
import { configurationPaths } from '../../util/constants';
import { PortalUserAuditLogsTable } from './components/PortalUserAuditLogsTable';

export const PortalUserAuditLogs = () => {
  const { isLoading: merchantInfoLoading } = useMerchant();
  const canManagePortalUsers = useCanManagePortalUsers();

  if (!canManagePortalUsers) {
    return <Navigate to={configurationPaths.SETTINGS} replace />;
  }

  return (
    <PageWrapper
      data-testid="PORTAL_USER_AUDIT_LOGS"
      title="User audit logs"
      description="Review create, update, delete, and access-email activity for portal users."
      isLoading={merchantInfoLoading}
      sx={{ width: '100%' }}
    >
      <Box>
        <PortalUserAuditLogsTable />
      </Box>
    </PageWrapper>
  );
};
